import React, { useState } from "react";
import { MapPin, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fetchPincodeInfo } from "@/lib/api";
import PincodeSelector from "@/components/PincodeSelector";
import { T } from "@/i18n";

const KEY = "vb.pinReminderDismissed";

// New browsing session without a PIN: ask for one. The Profile PIN is only an optional one-tap suggestion.
export default function PinReminder() {
  const { pincode, setPincode, user } = useApp();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(KEY) === "1");
  if (pincode || dismissed) return null;
  const dismiss = () => { sessionStorage.setItem(KEY, "1"); setDismissed(true); };
  const profilePin = /^\d{6}$/.test(user?.pincode || "") ? user.pincode : "";
  const useProfilePin = () => fetchPincodeInfo(profilePin).then((i) => setPincode(profilePin, i?.area || null)).catch(() => setPincode(profilePin, null));
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4" data-testid="pin-reminder">
      <div className="flex items-center gap-2 sm:gap-3 flex-wrap bg-amber-50 border border-amber-100 rounded-2xl px-3 py-2.5 sm:px-4">
        <MapPin className="w-4 h-4 text-amber-700 flex-shrink-0" />
        <div className="flex-1 min-w-[9rem] text-sm text-amber-900">
          <span className="font-semibold"><T k="home.pinTitle" /></span>
          <span className="hidden sm:inline"> — aas-paas ki shops, products aur offers dekhne ke liye.</span>
        </div>
        {profilePin && (
          <button type="button" onClick={useProfilePin} className="flex-shrink-0 rounded-full border border-emerald-300 bg-white hover:bg-emerald-50 text-emerald-800 text-xs font-semibold px-3 py-1.5 transition-colors" data-testid="pin-reminder-profile-pin">
            Use {profilePin}
          </button>
        )}
        <PincodeSelector
          trigger={
            <button className="flex-shrink-0 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white text-xs font-semibold px-3 py-1.5 transition-colors" data-testid="pin-reminder-select-btn">
              <T k="home.pinSelect" />
            </button>
          }
        />
        <button onClick={dismiss} className="p-1 text-amber-700 hover:text-amber-900 flex-shrink-0" aria-label="Dismiss" data-testid="pin-reminder-dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
